module.exports = __webpack_public_path__ + "img/slide6-en.cfb02920.png";